import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import Privacy from '../Common/Privacy';
import ProctorTypeList from '../Modules/ProctorTypeList';
import ExamAttachmentsList from './ExamAttachmentsList';

const ExamDetailedInfo = observer(class ExamDetailedInfo extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.toggle = this.toggle.bind(this);
  }

  componentWillMount() {
    this.state = {
      expanded: false
    }
  }

  toggle() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    const { translation } = this.props;
    const { exam } = this.props;

    return (
      <section className="panel__section">
        <h2
          className="panel__heading panel__heading--expand"
          onClick={this.toggle}
        >
          {translation.heading}

          <button
            className={`
              btn--expand
              ${this.state.expanded ? 'expanded' : ''}
            `}
            onClick={this.toggle}
            aria-controls="exam-detailed-info-panel"
            aria-expanded={this.state.expanded}
          >
            <span className="meta">View details</span>
          </button>
        </h2>

        <div 
          id="exam-detailed-info-panel"
          className={this.state.expanded ? 'expanded' : 'collapsed'}
        >
          <ul className="data">
            {exam.type.toLowerCase() !== 'written' &&
              <li>
                <strong className="subtitle">
                  {translation.url}
                </strong>

                <a
                  href={exam.examUrl}
                  title={exam.examUrl}
                >
                  {exam.examUrl}
                </a>
              </li>
            }
            {exam.type.toLowerCase() === 'written' &&
              <li>
                <strong className="subtitle">
                  {translation.examFile}
                </strong>

                <ExamAttachmentsList
                  {...this.props}
                  parent={this}
                  exam={exam}
                  overview={true}
                  hideDelete={true}
                />
              </li>
            }
            {exam.configuration.password &&
              <li>
                <strong className="subtitle">
                  {translation.password}
                </strong>

                <Privacy
                  show={translation.reveal}
                  hide={translation.hide}
                  private={exam.configuration.password}
                  {...this.props}
                />
              </li>
            }
            <li>
              <strong className="subtitle">
                {translation.attempts}
              </strong>

              {exam.configuration.attempts}
            </li>
          </ul>

          <ul className="data">
            {exam.configuration.proctorTypes.length > 0 &&
              <li className="data__lg">
                <strong className="subtitle">
                  {translation.proctor_types}
                </strong>

                <ProctorTypeList
                  proctorTypes={exam.configuration.proctorTypes}
                  {...this.props}
                />
              </li>
            }
          </ul>

          <ul className="data">
            {exam.configuration.studentNotes &&
              <li className="data__lg">
                <strong className="subtitle">
                  {translation.student_notes}
                </strong>

                {exam.configuration.studentNotes}
              </li>
            }
            {exam.configuration.proctorNotes &&
              <li className="data__lg">
                <strong className="subtitle">
                  {translation.proctor_notes}
                </strong>

                {exam.configuration.proctorNotes}
              </li>
            }
          </ul>
        </div>
      </section>
    )
  }
})

export default translate('ExamDetailedInfo')(ExamDetailedInfo);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ExamDetailedInfo.js